import { Link, useLocation } from "react-router-dom";
import { Home, Mountain, Mic, Users, MessageCircle } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", Icon: Home },
  { to: "/rooms", label: "Rooms", Icon: Mountain },
  { to: "/studio", label: "Studio", Icon: Mic },
  { to: "/about", label: "About", Icon: Users },
  { to: "/contact", label: "Apply", Icon: MessageCircle },
];

// One mobile bottom bar for every public page.
const PublicBottomNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#FBF7F1] border-t border-stone-200 px-2 pt-1.5 pb-[calc(0.375rem+env(safe-area-inset-bottom))]" data-testid="public-bottom-nav">
      <div className="flex items-center justify-around">
        {ITEMS.map(({ to, label, Icon }) => (
          <Link
            key={to}
            to={to}
            className={`flex flex-col items-center gap-1 px-3 py-1.5 min-w-[56px] ${pathname === to ? "text-[#C85A38]" : "text-[#2E2A26]/60"}`}
            aria-current={pathname === to ? "page" : undefined}
            data-testid={`bottom-nav-${label.toLowerCase()}`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-xs">{label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PublicBottomNav;
